import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'primereact/progressbar';
import moment from 'moment';
import styles from './InvoiceStatistics.styles.scss';
import receipt from '../../../assets/png/receipt.png';

const InvoiceStatistics = ({ statistics, title }) => {
  const { t } = useTranslation();

  const progressPercentage = (
    ((statistics.thisYear ?? 0) / statistics.limit) *
    100
  ).toFixed(1);

  return (
    <div className={cn(styles.statistics)}>
      <div className={styles.welcome}>{title}</div>
      <div className="d-flex align-items-start gap-4">
        <div className={cn(styles.icon)}>
          <img src={receipt} width={37} height={37} alt="Receipt" />
        </div>
        <div className="data">
          <div className={styles.total}>
            {t('invoice_list.total_invoices_generated', {
              year: moment().year(),
            })}
          </div>
          <div className={styles.limit}>
            {t('invoice_list.invoices_generated_of', {
              thisYear: statistics.thisYear ?? 0,
              limit: statistics.limit,
            })}
          </div>
          <div className="d-flex flex-row align-items-center gap-2 limit-bar fw-bold">
            <ProgressBar
              className={styles.progressBar}
              value={progressPercentage}
              showValue={false}
              color="#547D84"
            />
            {isNaN(progressPercentage) ? '0.0' : progressPercentage}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(InvoiceStatistics);
